import { z } from 'zod';

export const contactPriceSchema = z.object({
  custom: z.object({
    text1416: z.string().optional(),
    text1329: z.string().optional(),
    text147: z.string().optional(),
  }),
  name: z.string().min(1, { message: 'Meno je povinné pole' }),
  email: z
    .string()
    .min(1, { message: 'Email je povinné pole' })
    .email({ message: 'Nesprávny formát emailu' }),
  phone: z.string().min(1, { message: 'Telefón je povinné pole' }),
  text: z.string().optional(),
  gdpr: z
    .boolean()
    .refine((val) => val === true, { message: 'Súhlas s GDPR je povinný' }),
  'g-recaptcha-response': z.string().optional(),
});

export type ContactPriceFormValues = z.infer<typeof contactPriceSchema>;